<div class="pipeline-editor">
  <ts-loading-overlay
    *ngIf="loading$ | async"
    [message]="'info.loading_data'"
  ></ts-loading-overlay>
  <ts-loading-overlay
    *ngIf="saving$ | async"
    [message]="'alert.saving'"
  ></ts-loading-overlay>

  <header class="pipeline-editor__header">
    <h1>{{ 'title.pipeline_editor' | translate }}</h1>
  </header>

  <div class="pipeline-editor__body">
    <form [formGroup]="form" class="pipeline-editor__form">
      <div class="pipeline-editor__field" formGroupName="name">
        <label class="pipeline-editor__field-label">
          {{ 'label.display_name' | translate | uppercase }}
        </label>
        <div
          class="pipeline-editor__lang-row"
          *ngFor="let lang of supportedLanguages"
        >
          <label
            class="pipeline-editor__lang-label"
            [for]="'pipeline-editor-name-' + lang.value"
          >
            {{ lang.label | translate | uppercase }}
          </label>
          <input
            [id]="'pipeline-editor-name-' + lang.value"
            class="ts-input"
            type="text"
            [formControlName]="lang.value"
          />
        </div>
        <div
          class="pipeline-editor__error"
          *ngIf="
            (displayNameValid$ | async) === false && form.controls.name.dirty
          "
        >
          <i class="ri-error-warning-line" aria-hidden="true"></i>
          <span>{{ 'error.en_translation' | translate }}</span>
        </div>
      </div>

      <div class="pipeline-editor__field" formGroupName="description">
        <label class="pipeline-editor__field-label">
          {{ 'label.description' | translate | uppercase }}
        </label>
        <div
          class="pipeline-editor__lang-row"
          *ngFor="let lang of supportedLanguages"
        >
          <label
            class="pipeline-editor__lang-label"
            [for]="'pipeline-editor-description-' + lang.value"
          >
            {{ lang.label | translate | uppercase }}
          </label>
          <textarea
            [id]="'pipeline-editor-description-' + lang.value"
            class="ts-textarea"
            rows="2"
            [formControlName]="lang.value"
          ></textarea>
        </div>
      </div>

      <div class="pipeline-editor__field">
        <label class="pipeline-editor__field-label">
          {{ 'core.environment' | translate | uppercase }}
        </label>
        <mat-radio-group
          formControlName="env"
          class="pipeline-editor__env-group"
        >
          <mat-radio-button
            [value]="PipelineEnvironment.CLOUD"
            [matTooltip]="
              (canChangeEnv$ | async) === false
                ? ('tooltip.environment_disabled' | translate)
                : null
            "
          >
            {{ 'core.cloud' | translate }}
          </mat-radio-button>
          <mat-radio-button
            [value]="PipelineEnvironment.EDGE"
            [matTooltip]="
              (canChangeEnv$ | async) === false
                ? ('tooltip.environment_disabled' | translate)
                : null
            "
          >
            {{ 'core.edge' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </form>

    <section class="pipeline-editor__steps">
      <ts-pipeline-step-management-list
        [items]="(stepListItems$ | async) ?? []"
        [loading]="(stepListLoading$ | async) ?? false"
        [disabled]="(stepListDisabled$ | async) ?? false"
        (addClicked)="onAddStep()"
        (editClicked)="onEditStep($event)"
        (visualizeClicked)="onEditStep($event)"
        (removeConfirmed)="onRemoveStep($event)"
        (reordered)="onStepsReordered($event)"
      ></ts-pipeline-step-management-list>
    </section>

    <div *ngIf="error$ | async as error" class="pipeline-editor__error">
      <i class="ri-error-warning-line" aria-hidden="true"></i>
      <span>{{ error.key | translate: error.params }}</span>
    </div>
  </div>

  <footer class="pipeline-editor__footer">
    <button
      type="button"
      class="btn btn-outline-primary pipeline-editor__action"
      (click)="onCancel()"
    >
      <i class="ri-close-fill"></i>
      {{ 'button.cancel' | translate }}
    </button>
    <button
      *ngIf="isAdmin$ | async"
      type="button"
      class="btn btn-primary pipeline-editor__action"
      [disabled]="
        (displayNameValid$ | async) === false ||
        (hasSteps$ | async) === false ||
        (saving$ | async) === true ||
        !!(error$ | async)
      "
      data-cy="pipeline-editor-save"
      (click)="onSave()"
    >
      <i class="ri-save-line"></i>
      {{ confirmLabelKey | translate }}
    </button>
  </footer>
</div>
